import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class CpCoverablesService {

    static addCPLocation(quoteID, cpLocation, sessionID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'addLocation',
            [quoteID, cpLocation, sessionID],
            additionalHeaders
        );
    }

    static updateCPLocation(quoteID, cpLocation, sessionID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'updateLocation',
            [quoteID, cpLocation, sessionID],
            additionalHeaders
        );
    }

    static removeCPLocation(quoteID, cpLocation, sessionID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'removeLocation_TWIA',
            [quoteID, cpLocation, sessionID],
            additionalHeaders
        );
    }

    static removeCPUnwantedLocation(quoteID, cpLocations, sessionID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'removeUnwantedLocation_TWIA',
            [quoteID, cpLocations, sessionID],
            additionalHeaders
        );
    }

    static addCPBuilding(quoteID, cpLocationId, cpBuilding, sessionUUID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'addBuilding',
            [quoteID, cpLocationId, cpBuilding, sessionUUID],
            additionalHeaders
        );
    }

    static updateCPBuilding(quoteID, cpLocationId, cpBuilding, sessionUUID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'updateBuilding',
            [quoteID, cpLocationId, cpBuilding, sessionUUID],
            additionalHeaders
        );
    }

    static removeCPBuilding(quoteID, cpLocationId, cpBuildingId, sessionID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'removeBuilding',
            [quoteID, cpLocationId, cpBuildingId, sessionID],
            additionalHeaders
        );
    }

    static updateCPBuildingCoverages(quoteID, cpLocationId, cpBuildingId, sessionID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'updateBuildingCoverages',
            [quoteID, cpLocationId, cpBuildingId, sessionID],
            additionalHeaders
        );
    }
    
    // Commercial Quote - Coverages Page - Add Blanket Coverage
    static addCPBlanket_TWIA(quoteID, cpLocationId, cpBuildingId, sessionUUID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'addBlanket_TWIA', 
            [quoteID, cpLocationId, cpBuildingId, sessionUUID],
            additionalHeaders
        );
    }

    // Commercial Quote - Coverages Page - Remove Blanket Coverage
    static removeCPBlanket_TWIA(quoteID, cpBlanketId, sessionUUID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'removeBlanket_TWIA', 
            [quoteID, cpBlanketId, sessionUUID],
            additionalHeaders
        );
    }

    static getLocationsAndBuildingsForJob_TWIA(quoteID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'getLocationsAndBuildings',
            [quoteID],
            additionalHeaders
        );
    }

    static getLocationsAndBuildingsForPolicy_TWIA(policyNumber, sessionUUID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cpcoverables'),
            'getLocationsAndBuildingsForPolicy_TWIA',
            [policyNumber, sessionUUID],
            additionalHeaders
        );
    }
}
